<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
    <div class="flex flex-col w-full h-full min-h-0 overflow-hidden p-1">
      <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
      <div class="flex flex-1 min-h-0 overflow-hidden">
        <div class="z-[2] flex-[0.3] min-w-[150px] min-h-0 flex-shrink flex flex-col overflow-hidden">
          <div class="mb-2">
            <p-button class="outlined-button" size="small" severity="success" label="Add Load" outlined="true" (onClick)="addLoad()"></p-button>
          </div>
          <div class="flex-1 min-h-0 overflow-auto">
            <p-listbox 
              [options]="loadCases" 
              [(ngModel)]="selectedLoad" 
              optionLabel="name" 
              (onChange)="onLoadSelect($event)"
              [scrollHeight]="''">
              <ng-template let-load pTemplate="item">
                <div class="flex items-center justify-between w-full">
                  <div class="text-left">
                    {{ load.name }}
                  </div>
              
                  <div class="flex items-center">
                    <i
                      class="pi pi-copy p-1 !text-cyan-400"
                      size="sm"
                      pTooltip="Clone Load"
                      (click)="cloneLoad(load)">
                    </i>
                    
                    <i
                      class="pi pi-trash !text-red-400" 
                      size="sm" 
                      (click)="deleteLoad(load)">
                    </i>
                  </div>
                </div>
              </ng-template>
            </p-listbox>
          </div>
        </div>

        <div class="flex-[0.7] min-w-0 min-h-0 p-2 overflow-hidden">
          <app-pre-install-data 
            [disabled]="loadCases?.length === 0" 
            [preInstallLoad]="selectedLoadDetails()"
            (preInstallLoadUpdated)="updateOrCreateLoad($event)" [userUnits]="userUnits" [isCemented]="isCemented"
            [shoeMd]="shoeDepth" [hangerMd]="hangerMd" [annularFLuidDensity]="annularFLuidDensity">
          </app-pre-install-data>
        </div>
      </div>
    </div>
  </app-tool-loader>